/**
 * Session Events
 *
 * Simple event emitter for session-related events.
 * Used to communicate between API client and AuthProvider.
 */

type SessionEventType = 'session:expired' | 'session:refresh_failed';

type SessionEventHandler = () => void;

const handlers: Map<SessionEventType, Set<SessionEventHandler>> = new Map();

export const sessionEvents = {
  /**
   * Subscribe to a session event
   */
  on(event: SessionEventType, handler: SessionEventHandler): () => void {
    if (!handlers.has(event)) {
      handlers.set(event, new Set());
    }
    handlers.get(event)!.add(handler);

    // Return unsubscribe function
    return () => {
      handlers.get(event)?.delete(handler);
    };
  },

  /**
   * Emit a session event
   */
  emit(event: SessionEventType): void {
    handlers.get(event)?.forEach((handler) => {
      try {
        handler();
      } catch (error) {
        console.error(`Error in session event handler for ${event}:`, error);
      }
    });
  },
};
